import React, { Component } from "react";
import "./style.scss";

import classnames from "classnames";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import {
  MemberGetMemberTab,
  AssignReferrer,
  DownlineList,
  ReferralRewardListing,
  DownlineHierarchy,
} from "./MemberGetMember/index";
import { withTranslation } from "react-i18next";

export class MemberGetMemberClass extends Component {
  state = {
    activeTab: "1",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  render() {
    let { t } = this.props;
    return (
      <div className="beautesoft-navlink customer-detail">
        <div className="filled-tabs">
          <div className="tabs-block">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggle("1");
                  }}
                >
                  {t("Assign referrer")}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "2",
                  })}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  {t("Downline list")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "3",
                  })}
                  onClick={() => {
                    this.toggle("3");
                  }}
                >
                  {t("Downline Hierarchy")}
                </NavLink>
              </NavItem>
              <NavItem className="text-nowrap">
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "4",
                  })}
                  onClick={() => {
                    this.toggle("4");
                  }}
                >
                  {t("referral reward listing")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              {this.state.activeTab === "1" ? (
                <AssignReferrer id={this.props.id} />
              ) : (
                ""
              )}
            </TabPane>

            <TabPane tabId="2">
              {this.state.activeTab === "2" ? (
                // <PurchaseHistory />
                <DownlineList id={this.props.id} />
              ) : (
                ""
              )}
            </TabPane>
            <TabPane tabId="3">
              {this.state.activeTab === "3" ? (
                // <Appointments />
                <DownlineHierarchy id={this.props.id} />
              ) : (
                ""
              )}
            </TabPane>
            <TabPane tabId="4">
              {this.state.activeTab === "4" ? (
                // <Appointments />
                <ReferralRewardListing id={this.props.id} />
              ) : (
                ""
              )}
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}

export const MemberGetMember = withTranslation()(MemberGetMemberClass);
